<template>
  <div>
    <div class="hidden lg:block py-8 filter-container mx-auto bg-white">
       <swiper
        :slides-per-view="swiperOptions.slidesPerView"
        :allow-touch-move="true"
        :space-between="40"
        :navigation="true"
        :modules="modules"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        @afterInit="afterInit"
        @reachEnd="reachEnd"
        @snapGridLengthChange="snapGridLengthChange"
    >
        <swiper-slide v-for="(category, parent_category) in categories" :key="parent_category">
            <h4 class="category-parent uppercase font-bold"><span>{{ category.name }} </span></h4>
            <div class="flex category-content">
                <div  
                    v-for="category_item in category.children" :key="category_item" 
                    class="category-item flex flex-col px-4" :class="{active:classActive(category_item.slug) ? 'active':''}"
                    >
                    <!--label :for="category.chk" class="relative cursor-pointer">
                      <input class="absolute opacity-0" 
                        :id="category_item.slug" 
                        :value="category_item.slug" 
                        type="checkbox" 
                        v-model="selected_categories" 
                        v-on:change="update_checked_lists"
                        />
                      <div class="icone mx-auto rounded">
                            <img v-bind:src="category_item.img_name" alt="">
                        </div>
                        <div class="libelle text-center montserrat" :class="active == category_item.slug?'active':''">{{ category_item.name }}</div>
                    </label-->
                    <!--router-link :to="{path:'/'+category.slug+'/'+category_item.short_slug+''}">
                        <div class="icone mx-auto rounded">
                            <img v-bind:src="category_item.img_name" alt="">
                        </div>
                        <div class="libelle text-center montserrat" :class="active == category_item.slug?'active':''">{{ category_item.name }}</div>
                    </router-link-->

                      <div class="icone mx-auto rounded"  @click="pushToParams(category_item.slug)">
                        <img v-bind:src="category_item.img_name" />
                      </div>
                      <div @click="pushToParams(category_item.slug)" class="libelle text-center montserrat" :class="active == category_item.slug?'active':''">{{ category_item.name }}</div>
                  </div>
            </div>
        </swiper-slide>
    </swiper>
    </div>
    <!-- mobile -->
  <div class="flex lg:hidden pt-8 pb-3 filter-container w-full overflow-x-scroll px-4 bg-white whitespace-nowrap">
    <div v-for="(category, parent_category) in categories" :key="parent_category" class="mx-4">
      <h4 class="category-parent uppercase font-bold"><span>{{ category.name }} </span></h4>
      <div class="flex category-content">
        <div
            v-for="category_item in category.children" :key="category_item"
            class="category-item flex flex-col px-4"
        >
          <div class="icone mx-auto rounded"  @click="pushToParams(category_item.slug)">
            <img v-bind:src="category_item.img_name" />
          </div>
          <div @click="pushToParams(category_item.slug)" class="libelle text-center montserrat" :class="active == category_item.slug?'active':''">{{ category_item.name }}</div>
        </div>
      </div>
    </div>
  </div>
  </div>
    
</template>

<script>
   //  import CategoryService from "@/services/CategoryService";
    import { Navigation } from 'swiper';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import store from '../store/index'

    import 'swiper/css';
    import 'swiper/css/navigation';

    export default {
    data() {
        return {
            url: null,
            categories: null,
            active:null,
            selected_categories: [],
            swiperOptions:{
              slidesPerView:"auto",
              breakpoints: {
                1030:{
                  slidesPerView:1
                }
              }
            },
        };
    },
    methods: {
        async getProducts(category_slug){
            this.active = category_slug
            await store.dispatch('fetchProductsCategories', {slug: category_slug}) 
        },
        async update_checked_lists() {
          await store.dispatch('searchMultiple', this.selected_categories)
        },
        async pushToParams(slug) {
          await store.dispatch('addQueryParams', slug)
          this.selected_categories = store.getters.getQueryParams;
          let categories = Array.from(this.selected_categories)
          let params = {
            'name' : 'AppProducts',
            'query' : {
              items:categories.join(',')
            }
          }
          this.$root.$router.push(params)

            console.log(this.selected_categories.length)
          if(this.selected_categories.length > 0) {
              console.log('search multiple')
            await store.dispatch('searchMultiple', this.selected_categories)
          } else {
              console.log('search single')
            await store.dispatch('fetchProducts')
          }

        },
        classActive(slug){
          return Array.from(this.selected_categories).includes(slug)
        }
    },
    async created() {

        if(this.$route.query.items) {
          const selected_categories = this.$route.query.items.split(',')
          if(selected_categories) {
            this.selected_categories = selected_categories
            await store.dispatch('searchMultiple', this.selected_categories)
          }
        }
        await store.dispatch('fetchCategories')
        const category = this.$route.params.category
        const sub_category = this.$route.params.sub_category
        this.active = `${category}_${sub_category}`
        this.categories = store.getters.getCategories
    },
    watch: {
        '$route.params' : {
            handler: function(r) {
                const category = r.category
                const sub_category = r.sub_category
                this.active = `${category}_${sub_category}`
            },
            deep: true,
            immediate: true
        }
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    computed:{},
    setup() {
      const onSwiper = (swiper) => {
        console.log(swiper);
      };
      const onSlideChange = () => {
        // console.log('slide change');
      };
      const afterInit = ( swiper ) => {
        swiper.snapGrid = swiper.slidesGrid.slice(0)
      }
      const reachEnd = (swiper) => {
        console.log(swiper)
        swiper.snapGrid = [...swiper.slidesGrid];
      }
      const snapGridLengthChange = (swiper) => {
        if( swiper.snapGrid.length != swiper.slidesGrid.length ){
          swiper.snapGrid = swiper.slidesGrid.slice(0);
        }
      }
      return {
        onSwiper,
        onSlideChange,
        afterInit,
        reachEnd,
        snapGridLengthChange,
        modules: [Navigation]
      };
    }
}
</script>

<style scoped>
    .icone {
        width: 28px;
        height: 28px;
        /*background-color:rgb(218, 218, 218);*/
    }
    .icone:hover + .libelle, .libelle:hover  {
      color:rgb(225, 102, 0)
    }
    .libelle {
        padding-top: 8px;
        font-size: 13px;
    }
    .category-item {
        cursor: pointer;
    }
    .swiper {
        padding: 0 50px;
    }

    .swiper-slide {
      width: auto;
    }
    .category-item.flex.flex-col.px-4 {
      align-items: center;
    }
    input[type="checkbox"]:checked + .icone + .libelle {
      color:rgb(225, 102, 0)
    }
    @media(min-width: 1200px) {
      .category-item.flex.flex-col.px-4 {
        max-width: 150px;
      }
    }
    .swiper-button-next, .swiper-button-prev {
        width:60px;
        height: 60px;
        border-radius: 50%;
        background-color: lightgray;
    }
    
    .category-content .libelle.active,
    .active {
        color:rgb(225, 102, 0)
    }
    .category-parent span {
        display: inline-block;
        padding-bottom: .5rem;
        border-bottom: 2px solid rgb(95, 68, 52);
    }
    .swiper-slide-active .category-parent span {
        border-bottom: 2px solid rgb(225, 102, 0);
    }
    .swiper:after,
    .swiper:before {
        position: absolute;
        width: 50px;
        height: 100%;
        background: white;
        content: "";
        z-index: 2;
        top: 0;
    }
    .swiper:before { left: 0 }
    .swiper:after {  
        
        right: 0; 
        
        }
</style>